import { Stack, TableRow, Typography } from '@mui/material';
import { useMemo } from 'react';

import { TableCell } from '@occc-app/design-system';
import { StatusIndicator, TrendBadgeDelta } from '@occc/ui-design-system';

import {
  formatInt,
  formatUsdCents,
  getScanDataSubmissionStatusParams,
} from '../tobacco-submissions.utils';
import {
  RetailerNetworkScanDataSubmission,
  ScanDataSubmissionType,
} from '../tobacco-submissions.types';

const SUBMISSION_TYPE_LABEL: Record<ScanDataSubmissionType, string> = {
  CIRCANA_ALTRIA: 'Altria',
  CIRCANA_RJR: 'RJR',
  MSA: 'MSA',
};

type TobaccoWeeklySubmissionsTableRowDetailsProps = {
  submission: RetailerNetworkScanDataSubmission;
};

export const TobaccoWeeklySubmissionsTableRowDetails = ({
  submission,
}: TobaccoWeeklySubmissionsTableRowDetailsProps) => {
  const estimatedReimbursement =
    submission.estimatedReimbursements.multiUnit + submission.estimatedReimbursements.loyalty;

  const prevEstimatedReimbursement =
    submission.previousEstimatedReimbursements.multiUnit +
    submission.previousEstimatedReimbursements.loyalty;

  const statusParams = useMemo(
    () => getScanDataSubmissionStatusParams(submission.status),
    [submission.status],
  );

  return (
    <TableRow hover={false} sx={{ '&:last-child td': { border: 0 } }}>
      <TableCell>
        <Typography variant='body2'>{SUBMISSION_TYPE_LABEL[submission.type] || 'Other'}</Typography>
      </TableCell>

      <TableCell>
        <StatusIndicator color={statusParams.color} label={statusParams.label} />
      </TableCell>

      <TableCell>
        <Typography variant='body2'>{formatInt(submission.totalMultiUnitTransactions)}</Typography>
      </TableCell>

      <TableCell>
        <Typography variant='body2'>{formatInt(submission.totalLoyaltyTransactions)}</Typography>
      </TableCell>

      <TableCell align='right'>
        <Stack direction='row' alignItems='center' justifyContent='flex-end' gap={1}>
          <TrendBadgeDelta value={estimatedReimbursement} prevValue={prevEstimatedReimbursement} />
          <Typography variant='body2'>{formatUsdCents(estimatedReimbursement)}</Typography>
        </Stack>
      </TableCell>
    </TableRow>
  );
};
